import styled, {css} from "styled-components"

import {Card} from "@irati/ui/src/Layout"

export const Background = styled.div`
  min-height: 100vh;
  background-image: ${({theme}) => `linear-gradient(to bottom, ${theme.colors.primary2}, ${theme.colors.primary1})`};
`

export const StyledCard = styled(Card)`
  ${({theme}) => css`
    width: 500px;
    ${theme.mediaQueries.maxWidthMedia.tablet`
        width: calc(100% - ${theme.spacing.six});

    `}
  `}
`
